/**
 * Slice items to show only the current page.
 *
 * With Apollo's cache-and-network policy, the cache accumulates items
 * as users navigate sequentially. This function handles two scenarios:
 * 1. Sequential navigation: cache has accumulated pages, slice by index
 * 2. Direct URL landing: cache only has current page, use from start
 */
export function slicePageItems<T>(
  items: T[] | undefined,
  page: number,
  pageSize: number,
): T[] {
  if (!items) return [];
  const startIndex = page * pageSize;
  const endIndex = startIndex + pageSize;
  const hasFullHistory = items.length >= startIndex;
  return hasFullHistory
    ? items.slice(startIndex, endIndex)
    : items.slice(0, pageSize);
}

/**
 * Add a page's endCursor to the cache.
 * Returns a new Map (immutable update).
 */
export function cacheCursor(
  cursorCache: Map<number, string>,
  page: number,
  endCursor: string,
): Map<number, string> {
  const next = new Map(cursorCache);
  next.set(page, endCursor);
  return next;
}
